import { createElement } from 'react';
import { Card } from '@alifd/next';
import './index.scss';
const GraphicDisplay = function GraphicDisplay({ type, imgUrl, content, style: styleOption = {}, }) {
    return (createElement("div", { style: { display: "inline-block" } },
        type == 'left' && createElement(Card, { className: "free-card custom", free: true, style: styleOption },
            createElement(Card.Media, { image: imgUrl, style: { backgroundSize: "100% 100%" } }),
            createElement(Card.Header, { style: { flex: 1 }, title: content })),
        type == 'top' && createElement(Card, { className: "free-card", free: true, style: styleOption },
            createElement(Card.Media, { style: { height: 140, backgroundSize: "100% 100%" }, image: imgUrl }),
            createElement(Card.Header, { title: content }),
            createElement(Card.Divider, null)),
        type == 'right' && createElement(Card, { className: "free-card custom", free: true, style: styleOption },
            createElement(Card.Header, { title: content }),
            createElement(Card.Media, { image: imgUrl, style: { backgroundSize: "100% 100%" } })),
        type == 'bottom' && createElement(Card, { className: "free-card", free: true, style: styleOption },
            createElement(Card.Header, { title: content }),
            createElement(Card.Divider, null),
            createElement(Card.Media, { style: { height: 140, backgroundSize: "100% 100%" }, image: imgUrl })),
        type == 'leftTop' && createElement(Card, { className: "free-card free-card-right-top", free: true, style: styleOption },
            createElement(Card.Content, { style: { textIndent: "20px" } },
                createElement("img", { id: "example-element", align: 'left', className: "transition-all", src: imgUrl, width: "200", style: { marginRight: "10px" } }),
                " ",
                content)),
        type == 'rightTop' && createElement(Card, { className: "free-card free-card-right-top", free: true, style: styleOption },
            createElement(Card.Content, { style: { textIndent: "20px" } },
                createElement("img", { id: "example-element", align: 'right', className: "transition-all", src: imgUrl, width: "200", style: { marginLeft: "10px" } }),
                " ",
                content))));
};
export default GraphicDisplay;
